import { render, staticRenderFns } from "./transcript.vue?vue&type=template&id=b54ab3e8&"
import script from "./transcript.vue?vue&type=script&lang=js&"
export * from "./transcript.vue?vue&type=script&lang=js&"
import style0 from "./transcript.vue?vue&type=style&index=0&id=b54ab3e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports